import { useState } from 'react';

import { getRouteApi, useLocation, type ToOptions } from '@mint/admin-routing';

import { ExpandableSidebar, SidebarItem } from '@myn/mui';

import { useSideBarItems } from '../hooks/useSideBar.js';

const routeApi = getRouteApi('/_secured');

const SideBar = () => {
  const [isExpanded, setIsExpanded] = useState<Record<string, boolean>>({
    taxonomy: true,
  });
  const { pathname } = useLocation();
  const navigate = routeApi.useNavigate();
  const sidebarItems = useSideBarItems();
  const search = routeApi.useSearch();

  const handleItemClick = (itemId: string) => {
    setIsExpanded((prevState) => {
      return {
        ...prevState,
        [itemId]: !prevState[itemId],
      };
    });
  };

  const handleSubItemClick = (path: ToOptions['to']) => {
    navigate({
      to: path,
      search,
    } as ToOptions);
  };

  return (
    <ExpandableSidebar isShown>
      {sidebarItems.map((item) =>
        !item.hidden ? (
          <>
            <SidebarItem
              icon={item.icon}
              text={item.title}
              onItemClick={() =>
                item.path
                  ? handleSubItemClick(item.path)
                  : handleItemClick(item.id)
              }
              expandable={item.expandable}
              open={isExpanded[item.id]}
              selected={item.selected}
              variant="primary"
            />
            {isExpanded[item.id]
              ? item.subItems?.map((subItem) =>
                  !subItem.hidden ? (
                    <SidebarItem
                      key={subItem.id}
                      text={subItem.title}
                      onItemClick={() => handleSubItemClick(subItem.path)}
                      selected={
                        !!pathname.split('/').find((el) => el === subItem.id)
                      }
                      variant="secondary"
                    />
                  ) : null,
                )
              : null}
          </>
        ) : null,
      )}
    </ExpandableSidebar>
  );
};

export default SideBar;
